import { defineAsyncComponent } from 'vue'

export const IconChevronRight = defineAsyncComponent(() => import('./chevron-right.vue'))
export const IconExternalLink = defineAsyncComponent(() => import('./external-link.vue'))
export const IconFilter = defineAsyncComponent(() => import('./filter.vue'))
export const IconDownload = defineAsyncComponent(() => import('./download.vue'))
export const IconShare = defineAsyncComponent(() => import('./share.vue'))
